import { createBrowserRouter, Navigate } from 'react-router-dom'

import { ProtectedLayout } from './components/protectedLayout'
import { AuthProvider } from './contexts/AuthContext'
import { NotFound } from './not-found'
import { AppLayout } from './pages/_layouts/app'
import { AuthLayout } from './pages/_layouts/auth'
import { Admin } from './pages/app/admin'
import { Campaigns } from './pages/app/campaigns'
import { AwardedCampaigns } from './pages/app/campaigns/components/awardedCampaigns'
import { CampaignClientView } from './pages/app/campaigns/components/campaignClientView'
import { CampaignManagement } from './pages/app/campaigns/components/campaignManagement'
import { MyCampaigns } from './pages/app/campaigns/components/myCampaigns'
import { ParticipatingCampaigns } from './pages/app/campaigns/components/participatingCampaigns'
import { Checkout } from './pages/app/checkout'
import { PaymentSuccessScreen } from './pages/app/checkout/components/PaymentSuccessScreen'
import { Contact } from './pages/app/contact'
import { Drawer } from './pages/app/drawer'
import { FrequentlyAsked } from './pages/app/frequently-asked'
import { Home } from './pages/app/home'
import { SignIn } from './pages/auth/sign-in'
import { SignUp } from './pages/auth/sign-up'

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthProvider>
        <AppLayout />
      </AuthProvider>
    ),
    errorElement: <NotFound />,
    children: [
      {
        path: '/',
        element: <Navigate to="/inicio" replace />,
      },
      {
        path: '/inicio',
        element: <Home />,
      },
      {
        path: '/campanhas',
        element: <Campaigns />,
      },
      {
        path: '/contato',
        element: <Contact />,
      },
      {
        path: '/perguntas-frequentes',
        element: <FrequentlyAsked />,
      },
      {
        path: '/admin',
        element: (
          <ProtectedLayout>
            <Admin />
          </ProtectedLayout>
        ),
      },
      {
        path: '/campanhas/:rifaId',
        children: [
          {
            path: 'gerenciamento',
            element: (
              <ProtectedLayout>
                <CampaignManagement />
              </ProtectedLayout>
            ),
          },
        ],
      },
      {
        path: '/campanhas/:rifaId',
        children: [
          {
            path: 'participando',
            element: (
              <ProtectedLayout>
                <CampaignClientView />
              </ProtectedLayout>
            ),
          },
          {
            path: 'pagamento-concluido',
            element: (
              <ProtectedLayout>
                <PaymentSuccessScreen />
              </ProtectedLayout>
            ),
          },
          {
            path: 'checkout',
            element: (
              <ProtectedLayout>
                <Checkout />
              </ProtectedLayout>
            ),
          },
          {
            path: 'sortear',
            element: (
              <ProtectedLayout>
                <Drawer />
              </ProtectedLayout>
            ),
          },
        ],
      },
      {
        path: '/campanhas/participando',
        element: (
          <ProtectedLayout>
            <ParticipatingCampaigns />
          </ProtectedLayout>
        ),
      },
      {
        path: '/campanhas/minhas',
        element: (
          <ProtectedLayout>
            <MyCampaigns />
          </ProtectedLayout>
        ),
      },
      {
        path: '/campanhas/premiadas',
        element: <AwardedCampaigns />,
      },
    ],
  },
  {
    path: '/',
    element: (
      <AuthProvider>
        <AuthLayout />
      </AuthProvider>
    ),
    children: [
      {
        path: '/sign-in',
        element: <SignIn />,
      },
      {
        path: '/sign-up',
        element: <SignUp />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
])
